module.exports = __webpack_public_path__ + "static/media/searchIcon.c8790136.svg";